export default {
      id: "notifications__approaching_geopoint-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__approaching_geopoint",
      toString: function () {
        return this.url;
      }
    }